module.exports = __webpack_public_path__ + "img/fugao.48a6a225.png";